import 'twin.macro';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
}

export function GlobalRemarkTitleWrapper(props: Props) {
  const { t } = useTranslation(['carnet']);
  return (
    <div className="break-inside-avoid" tw="py-3">
      <div tw="text-center font-semibold mb-3">
        {t('carnet:livret.generalRemarkOnStudent')}
      </div>
      {props.children}
    </div>
  );
}
